import * as React from 'react';
import { render } from 'react-dom';
import { FullService } from '../landing_pages/pages/FullService';
import '../terms_and_conditions/styles.scss';

const root = document.getElementById('full_service_shopper');
render(<FullService />, root);
